// extracted by mini-css-extract-plugin
export default {"container":"input_container__qcYQC","container--red":"input_container--red__o41k5"};